module.exports = __webpack_public_path__ + "img/status-promotion.ec28a84d.png";